import React, { createContext, useEffect, useState } from "react";
import auth from "auth";
import { isNil } from "ramda";

const UserContext = createContext();

const UserContextProvider = props => {
  const [user, setUser] = useState();
  const [token, setToken] = useState(auth.getBiblioboardDomainToken());
  const [loading, setLoading] = useState(true);

  const updateToken = token => {
    auth.setBiblioboardDomainCookie(token);
    setToken(token);
  };

  const logOut = () => {
    setLoading(true);
    setUser(null);
    updateToken(null);
  };

  useEffect(() => {
    if (isNil(token)) {
      auth.signIn().then(newToken => {
        if (!isNil(newToken)) {
          updateToken(newToken);
        }
      });
    } else {
      auth
        .fetchUser(token)
        .then(({ user }) => {
          setUser(user);
          setLoading(false);
        })
        .catch(err => updateToken(null));
    }
  }, [token]);

  return (
    <UserContext.Provider value={{ user, token, logOut, loading }}>
      {props.children}
    </UserContext.Provider>
  );
};

export { UserContext, UserContextProvider };
